import { Text } from '@shared/components';
import clsx from 'clsx';
import { ReactElement, ReactNode } from 'react';
import { el } from './classNames';

type DocViewerMessageProps = {
  action?: ReactNode;
  message: string;
};

export function DocViewerMessage({
  action,
  message,
}: DocViewerMessageProps): ReactElement {
  return (
    <div className={clsx(el`doc-container`, 'h-full min-h-0')}>
      <div className={el`doc`}>
        <Text className={el`no-doc-text`} type="body-lg">
          {message}
        </Text>
        {action && <div className="mt-4">{action}</div>}
      </div>
    </div>
  );
}
